import { Component, Input, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationService } from '@app/core/services/application/application.service';
import { NavController, NavParams, PopoverController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-cancel',
    templateUrl: './application-cancel.component.html',
    styleUrls: ['./application-cancel.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationCancelComponent implements OnInit {
    @Input() application: any = {};

    applicationId: string;

    constructor(
        private route: ActivatedRoute,
        private applicationService: ApplicationService,
        private navCtrl: NavController,
        private popCtrl: PopoverController,
        private navParams: NavParams
    ) {}

    ngOnInit() {
        this.applicationId = this.application.id;
    }
}
